/* eslint-disable react-refresh/only-export-components */
import { createContext, useState, useEffect, ReactNode } from 'react';
import { translations, SupportedLanguage, defaultLanguage, Translation } from '@/locales';
import { errorTranslator } from '@/utils/errorTranslator';

interface LanguageContextType {
  language: SupportedLanguage;
  setLanguage: (language: SupportedLanguage) => void;
  t: Translation;
}

export const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

interface LanguageProviderProps {
  children: ReactNode;
}

export const LanguageProvider = ({ children }: LanguageProviderProps) => {
  const [language, setLanguage] = useState<SupportedLanguage>(() => {
   /* // Try to get saved language from localStorage
    const savedLanguage = localStorage.getItem('language') as SupportedLanguage;
    if (savedLanguage && translations[savedLanguage]) {
      return savedLanguage;
    }

    // Try to detect browser language
    const browserLanguage = navigator.language.split('-')[0] as SupportedLanguage;
    if (translations[browserLanguage]) {
      return browserLanguage;
    }*/

    // Fall back to default language
    const lang = defaultLanguage;
    localStorage.setItem('language', lang);
    // Initialize error translator
    errorTranslator.setLanguage(lang);
    return lang;
  });

  useEffect(() => {
    // Save language preference to localStorage
    localStorage.setItem('language', language);
  }, [language]);

  const changeLanguage = (newLanguage: SupportedLanguage) => {
    setLanguage(newLanguage);
    // Keep error translator in sync
    errorTranslator.setLanguage(newLanguage);
  };

  const value = {
    language,
    setLanguage: changeLanguage,
    t: translations[language],
  };

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};
